import { call } from 'redux-saga/effects';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchReportForOutreachAggregate as fetchReportForOutreachAggregateRoutine,
  fetchOutreachAggregateOptions as fetchOutreachAggregateOptionsRoutine
} from '../routines';

export const fetchReportForOutreachAggregate = ({ payload: body }) =>
  sagaRoutineRequest(fetchReportForOutreachAggregateRoutine, {
    request: () => call(Api.fetchReportForOutreachAggregate, { body })
  });

export const fetchOutreachAggregateOptions = () =>
  sagaRoutineRequest(fetchOutreachAggregateOptionsRoutine, {
    request: () => call(Api.fetchOutreachAggregateOptions)
  });
